export enum ImageType {
  MAIN = "main",
  FRONT = "front",
  REAR = "rear",
  INTERIOR = "interior",
  FRONT360 = "exterior360_31",
  IMAGE = "image",
  PROFILE = "profile",
}
